import { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE, PROFILE_IMG_BASE } from "@config/env";


const post = (ep, fields) => { const fd=new FormData(); Object.entries(fields).forEach(([k,v])=>fd.append(k,v)); return axios.post(`${API_BASE}${ep}`,fd).then(r=>r.data).catch(()=>null); };

function Input({ label, value, onChange, placeholder, type="text" }) {
  return (
    <div style={{ marginBottom:16 }}>
      <label style={{ fontSize:12, fontWeight:700, color:"#374151", display:"block", marginBottom:6, textTransform:"uppercase", letterSpacing:"0.05em" }}>{label}</label>
      <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
        style={{ width:"100%", boxSizing:"border-box", padding:"11px 12px", border:"1.5px solid #E5E7EB", borderRadius:10, fontSize:14, outline:"none", fontFamily:"inherit", color:"#111827", transition:"all 0.18s" }}
        onFocus={e=>{e.target.style.borderColor="#2563EB";e.target.style.boxShadow="0 0 0 3px rgba(79,70,229,0.1)"}}
        onBlur={e=>{e.target.style.borderColor="#E5E7EB";e.target.style.boxShadow="none"}} />
    </div>
  );
}

export default function ResetPasswordPage() {
  const { resetLink } = useParams();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [linkValid, setLinkValid] = useState(false);
  const [password, setPassword] = useState("");
  const [cPassword, setCPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!resetLink) return;
    post("get-reset-link", { link: resetLink }).then(data => {
      setLinkValid(data?.status === 1);
      setChecking(false);
      if (data?.status !== 1) setError(data?.message || "This link is invalid or has expired.");
    });
  }, [resetLink]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!password.trim()) { setError("Enter a valid password"); return; }
    if (!cPassword.trim()) { setError("Enter confirm password"); return; }
    if (password !== cPassword) { setError("Passwords do not match"); return; }
    setBusy(true);
    const res = await post("reset-password", { password, confirm_password: cPassword, link: resetLink });
    setBusy(false);
    if (res?.status === 1) {
      setSuccess(res.message || "Password reset! Redirecting to login...");
      setPassword(""); setCPassword("");
      setTimeout(() => navigate("/login"), 2000);
    } else {
      setError(res?.message || "Something went wrong. Please try again.");
    }
  };

  return (
    <div style={{ minHeight:"100vh", background:"#F3F4F6", display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
      <div style={{ width:"100%", maxWidth:440 }}>
        <div style={{ textAlign:"center", marginBottom:28 }}>
          <div style={{ fontSize:22, fontWeight:800, color:"#111827", letterSpacing:"-0.03em" }}>Firm<span style={{color:"#2563EB"}}>Connector</span></div>
        </div>
        <div style={{ background:"#fff", borderRadius:20, boxShadow:"0 4px 24px rgba(0,0,0,0.06)", padding:"32px 32px 28px", border:"1px solid #E5E7EB" }}>
          <div style={{ marginBottom:24 }}>
            <div style={{ width:44, height:44, borderRadius:12, background:"#EFF6FF", display:"flex", alignItems:"center", justifyContent:"center", marginBottom:14 }}>
              <i className="fa-solid fa-key" style={{ fontSize:18, color:"#2563EB" }} />
            </div>
            <h1 style={{ fontSize:20, fontWeight:800, color:"#111827", margin:0 }}>Reset Password</h1>
            <p style={{ fontSize:13, color:"#6B7280", margin:"6px 0 0" }}>Enter your new password below.</p>
          </div>

          {checking ? (
            <div style={{ textAlign:"center", padding:"24px 0", color:"#6B7280", fontSize:13 }}>
              <i className="fa-solid fa-spinner fa-spin" style={{marginRight:8}} />Verifying link...
            </div>
          ) : !linkValid ? (
            <>
              <div style={{ padding:"14px", background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:10, fontSize:13, color:"#DC2626", marginBottom:20 }}>
                {error}
              </div>
              <Link to="/forgot-password" className="fc-btn fc-btn-md fc-btn-primary" style={{ display:"block", textAlign:"center", textDecoration:"none", borderRadius:10 }}>
                Request new link
              </Link>
            </>
          ) : (
            <form onSubmit={handleSubmit}>
              {success && <div style={{ padding:"12px 14px", background:"#F0FDF4", border:"1px solid #BBF7D0", borderRadius:10, marginBottom:16, fontSize:13, color:"#14532D" }}><i className="fa-solid fa-circle-check" style={{marginRight:8}} />{success}</div>}
              {error && <div style={{ padding:"12px 14px", background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:10, marginBottom:16, fontSize:13, color:"#DC2626" }}><i className="fa-solid fa-circle-exclamation" style={{marginRight:8}} />{error}</div>}
              <Input label="New Password" type="password" value={password} onChange={setPassword} placeholder="Enter new password" />
              <Input label="Confirm Password" type="password" value={cPassword} onChange={setCPassword} placeholder="Confirm your new password" />
              <button type="submit" disabled={busy} className="fc-btn fc-btn-md fc-btn-primary" style={{ width:"100%", borderRadius:10, opacity:busy?0.7:1, marginTop:4 }}>
                {busy ? <><i className="fa-solid fa-spinner fa-spin" style={{fontSize:12}} /> Resetting...</> : "Reset Password"}
              </button>
            </form>
          )}
        </div>
        <div style={{ textAlign:"center", marginTop:20, fontSize:13, color:"#9CA3AF" }}>
          <Link to="/login" style={{ color:"#2563EB", fontWeight:600, textDecoration:"none" }}>← Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
